$(document).ready(function () {
  const target = document.querySelector(".ess-mi-numbers-section");
  const sectionOne = document.querySelector(".section--1");
  const sectionTwo = document.querySelector(".section--2");
  const sectionThree = document.querySelector(".section--3");
  const gifOne = document.querySelector(".ess-mi-numbers-section__animation-1");
  const gifTwo = document.querySelector(".ess-mi-numbers-section__animation-2");
  const gifThree = document.querySelector(
    ".ess-mi-numbers-section__animation-3"
  );

  const options = {
    rootMargin: "0px 0px -80% 0px",
  };

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.unobserve(target);

        // fade in section 1
        sectionOne.classList.add("show");

        // play gif, 2190ms + 1500ms delay
        setTimeout(() => {
          gifOne.src = "/pages/michigan/assets/img/ASTHO_MI_gif5.gif";
        }, 300);

        // fade in section two
        setTimeout(() => {
          sectionTwo.classList.add("show");
        }, 3390);

        // play gif, 1190ms + 1500ms delay
        setTimeout(() => {
          gifTwo.src = "/pages/michigan/assets/img/ASTHO_MI_gif6.gif";
        }, 3690);

        // fade in section three
        setTimeout(() => {
          sectionThree.classList.add("show");
        }, 6380);

        // play gif
        setTimeout(() => {
          gifThree.src = "/pages/michigan/assets/img/ASTHO_MI_gif7.gif";
        }, 6680);
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  observer.observe(target);
});
